"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports.capitalize = capitalize;
exports.countWords = countWords;
exports.default = void 0;
exports.latenize = latenize;
exports.leftTrim = leftTrim;
exports.rightTrim = rightTrim;
exports.truncate = truncate;
exports.upperFirst = upperFirst;
/**
 * Retorna a string com a primeira letra maiúscula.
 *
 * @param {string} str
 * @returns {string}
 */
function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Todas as letras ficarão minúsculas, sem acento e sem cedílha.
 *
 * @param {string} str
 * @returns {string}
 */
function latenize(str) {
  if (str) {
    const map = {
      a: "ä|å|á|à|ã|â",
      e: "ë|é|è|ê",
      i: "ï|í|ì|î",
      o: "ö|ó|ò|ô|õ",
      u: "ü|ú|ù|û|ü",
      c: "ç|Ç",
      n: "ñ|Ñ",
      y: "ý|ÿ",
    };
    str = str.toLowerCase();
    for (const pattern in map) {
      str = str.replace(new RegExp(map[pattern], "g"), pattern);
    }
  }
  return str;
}

/**
 * Remove o caracter especificado do começo (fim à esquerda) da string
 * Se o caracter não for especificado, remove os espaços do começo da string.
 *
 * @param {string} str
 * @param {string} char
 * @returns {string}
 */
function leftTrim(str, char = "\\s") {
  const re = new RegExp(`^${char}+`);
  return str.replace(re, "");
}

/**
 * Remove o caracter especificado do final (fim à direita) da string
 * Se o caracter não for especificado, remove os espaços do final da string.
 *
 * @param {string} str
 * @param {string} char
 * @returns {string}
 */
function rightTrim(str, char = "\\s") {
  const re = new RegExp(`[${char}]+$`);
  return str.replace(re, "");
}

/**
 * Conta as palavras em uma string
 *
 * @param {string} str
 * @returns {string}
 */
function countWords(str) {
  return str
    .replace(/\s+/g, " ")
    .replace(/^\s+|\s+$/g, "")
    .split(" ").length;
}

/**
 * Torna a primeira letra de cada palavra da string maiúscula, exceto as stopwords informadas.
 *
 * @param {string} str
 * @param {object} options
 */
function capitalize(
  str,
  options = {
    stopwords: [
      "de",
      "do",
      "da",
      "dos",
      "das",
      "e",
      "à",
      "a",
      "o",
      "ao",
      "as",
      "os",
      "com",
      "em",
      "no",
      "na",
      "nos",
      "nas",
      "por",
    ],
  }
) {
  if (str) {
    let s = str.split(" ").map((word) => {
      const w = word.toLowerCase();
      return options.stopwords.includes(w)
        ? w
        : w.charAt(0).toUpperCase() + w.slice(1);
    });
    s = s.join(" ");
    return s;
  }
  return "";
}

/**
 * Corta a string e concatena com um sufixo
 *
 * @param {string} text
 * @param {object} config
 * @returns {string}
 */
function truncate(
  text,
  options = {
    suffix: "...",
    maxLength: 280,
  }
) {
  if (typeof text !== "string") {
    return text;
  }
  if (text.length > options.maxLength) {
    let truncatedText = text.slice(0, options.maxLength).trim();
    const lastIndexOfSpaceChar = truncatedText.lastIndexOf(" ");
    truncatedText = truncatedText.slice(0, lastIndexOfSpaceChar);
    return `${truncatedText}${options.suffix}`;
  }
  return text;
}
var _default = {
  capitalize,
  countWords,
  latenize,
  leftTrim,
  rightTrim,
  truncate,
  upperFirst,
};
exports.default = _default;
